import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { hasMarketingConsent, onConsentGranted, trackMeta } from "../lib/metaPixel";

const LANDING_PATH = "/fotografia-case-vacanze";

// PageView sulle navigazioni client-side (SPA) + ViewContent sulla landing case vacanze.
// Il PageView iniziale lo emette il loader del pixel al momento del consenso.
// ViewContent: una sola volta per ciascuna VISITA della landing (reset uscendo dalla rotta).
// La guardia viewContentSent è condivisa tra i due percorsi di invio (route effect e listener
// del consenso): senza, con consenso già memorizzato l'evento partiva due volte (una subito
// dal route effect e una al resolve del caricamento pixel).
export const MetaPixelTracker = () => {
  const location = useLocation();
  const prevRoute = useRef(null);
  const viewContentSent = useRef(false);

  const routeKey = `${location.key}:${location.pathname}${location.search}`;

  const fireViewContent = () => {
    if (!hasMarketingConsent()) return; // senza consenso: niente invio (verrà emesso al consenso)
    if (viewContentSent.current) return; // già inviato per questa visita della landing
    viewContentSent.current = true;
    trackMeta("ViewContent", { content_name: "Landing Case Vacanze", content_type: "landing_page" });
  };

  useEffect(() => {
    if (prevRoute.current !== null && prevRoute.current !== routeKey) {
      trackMeta("PageView");
    }
    prevRoute.current = routeKey;

    const onLanding = location.pathname === LANDING_PATH;
    if (!onLanding) viewContentSent.current = false; // uscita dalla landing: prossima visita = nuovo ViewContent
    else fireViewContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeKey]);

  // Se il consenso arriva mentre l'utente è già sulla landing, il ViewContent parte ora
  useEffect(() => {
    if (location.pathname !== LANDING_PATH) return undefined;
    return onConsentGranted(fireViewContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};
